import { computed, defineComponent, ref, } from '@vue/composition-api';
import Modal from '@/components/Modal/Modal.vue';
import SurveyQuestionReadonly from './SurveyQuestionReadonly.vue';
import LoadingSpinner from '@/components/Loaders/LoadingSpinner.vue';
import Vue from 'vue';
export default defineComponent({
    name: 'SurveyAnswersAcceptanceModal',
    components: {
        Modal,
        SurveyQuestionReadonly,
        LoadingSpinner,
    },
    props: {
        survey: {
            type: Object,
            required: true,
        },
        place: {
            type: Object,
            default: null,
        },
        userFullName: {
            type: String,
            default: null,
        },
        show: Boolean,
        canManageStatus: {
            type: Boolean,
            default: false,
        },
        surveyUserId: {
            type: String,
            default: null,
        },
        statuses: {
            type: Array,
            default: null,
        },
    },
    setup(props, ctx) {
        const questionLoadingStates = ref({});
        const isLoading = computed(() => Object.values(questionLoadingStates.value).some(Boolean));
        const updateShow = () => {
            ctx.emit('close');
        };
        const handleStatusChange = (questionIndex, newStatus) => {
            ctx.emit('status-changed', questionIndex, newStatus);
        };
        return {
            isLoading,
            questionLoadingStates,
            updateShow,
            handleStatusChange,
            handleChangeQuestionLoading: ({ id, value, }) => {
                Vue.set(questionLoadingStates.value, id.value, value);
            },
        };
    },
});
